export var ItemStatus;
(function (ItemStatus) {
    ItemStatus["REPORT"] = "report";
    ItemStatus["QUEUE"] = "queue";
    ItemStatus["CANDIDATE"] = "candidate";
    ItemStatus["DISMISSED"] = "dismissed";
    ItemStatus["FEATURED"] = "featured";
    ItemStatus["FEATURED_DISABLED"] = "featuredDisabled";
})(ItemStatus || (ItemStatus = {}));
export var ItemAction;
(function (ItemAction) {
    ItemAction["EDIT"] = "edit";
    ItemAction["SELECT"] = "select";
    ItemAction["DISMISS"] = "dismiss";
    ItemAction["QUEUE"] = "queue";
    ItemAction["REMOVE"] = "remove";
    ItemAction["UNDO"] = "undo";
})(ItemAction || (ItemAction = {}));
